import AddWorkOrder from './Containers/add-work-order';
import AddScheduleWorkOrder from './Containers/add-schedule-work-order';
import WorkOrderDetail from './Containers/work-order-detail';
import WorkOrderList from './Containers/work-orders-list';
import AddPurchaseOrder from './Containers/add-purchase-order';
import PurchasesOrderDetail from './Containers/purchase-order-detail';
import AddBackCharge from './Containers/add-back-charge';
import BackChargeDetail from './Containers/back-charge-detail';
import { AppSettings } from '../constants';

export default [
  {
    path: '/request-for-services/work-order/add/:RFSID',
    component: AddWorkOrder,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/request-for-services/schedule-work-order/add/:RFSID',
    component: AddScheduleWorkOrder,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/request-for-services/work-order/detail/:RFSID/:WorkOrderId',
    component: WorkOrderDetail,
    private: true,
    portal: ['Builder', 'Subcontractor','Homeowner']
  },
  {
    path: '/work-order-list',
    component: WorkOrderList,
    private: true,
    portal: ['Subcontractor', 'Builder'],
    menu: {
      name: 'Work orders',
      order: 8,
      icons: 'icon-work-orders-ic',
      className: AppSettings.clientTypeValue !== 'Subcontractor' ? 'menu-divide' : ''
    }
  },
  {
    path: '/request-for-services/work-order/purchase-order/:RFSID/:WOID/add',
    component: AddPurchaseOrder,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/request-for-services/work-order/purchase-order/:RFSID/:WOID/detail/:POID',
    component: PurchasesOrderDetail,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/request-for-services/work-order/back-charge/:RFSID/:WOID/:POID/add',
    component: AddBackCharge,
    private: true,
    portal: ['Builder']
  },
  {
    path: '/request-for-services/work-order/back-charge/:RFSID/:WOID/:POID/detail/:BCID',
    component: BackChargeDetail,
    private: true,
    portal: ['Builder']
  }
];



// WEBPACK FOOTER //
// ./src/Work-Orders/routes.js